import { Button } from '@bymason-private/legacy-pattern-components';
import { UsersView as Users } from '@bymason-private/controller-shared-widgets';
import { useState } from 'react';
import Layout from '../../common/layout';

export default function UsersView() {
  const [showInviteUserModal, setShowInviteUserModal] = useState(false);

  const handleInviteUserModalOpen = () => {
    setShowInviteUserModal(true);
  };
  const handleInviteUserModalClose = () => {
    setShowInviteUserModal(false);
  };

  return (
    <Layout
      // busy={accountBusy}
      headerText='Users'
      headerRightAdornment={
        <Button variant='outlined' onClick={handleInviteUserModalOpen}>
          Invite user
        </Button>
      }
      stickyHeader
    >
      <Users showInviteUserModal={showInviteUserModal} onCloseInviteUserModal={handleInviteUserModalClose} />
    </Layout>
  );
}
